import { Button, ButtonProps } from '@shared/components/Button';
import { AnchoredTooltip } from '@shared/components/tooltip';
import { grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';

export function ModalCloseButton({ onClick, testID = 'modal-close-button' }: ButtonProps) {
  return (
    <Button
      icon="exit"
      iconOnly
      iconSize={grid(3.75)}
      variant="ghost"
      onClick={onClick}
      testID={testID}
    />
  );
}

export function ModalBackButton({ onClick, testID = 'modal-back-button' }: ButtonProps) {
  return (
    <Button
      icon="arrow-point-left"
      iconOnly
      iconSize={grid(3.75)}
      variant="ghost"
      onClick={onClick}
      testID={testID}
    />
  );
}

export function ModalResizeButton({
  onClick,
  testID = 'modal-resize-button',
  isExpanded,
  className,
}: ButtonProps & { isExpanded: boolean }) {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return null;
  }

  const icon = isExpanded ? 'arrows-collapse' : 'arrows-expand';
  const resizeTooltip = isExpanded ? i18n('common.shrink') : i18n('common.expand');
  const resizeLabel = isExpanded ? i18n('common.shrinkModal') : i18n('common.expandModal');

  return (
    <AnchoredTooltip tooltip={resizeTooltip} position="bottom">
      <Button
        icon={icon}
        iconOnly
        iconSize={grid(3.75)}
        variant="ghost"
        onClick={onClick}
        testID={testID}
        className={className}
        label={resizeLabel}
      />
    </AnchoredTooltip>
  );
}
